import { FC, useEffect, useRef } from 'react';

import SvgIcon, { SvgIconName } from '~src/shared/SvgIcon';
import { NotificationTypes } from '~src/store/app/interfaces';

import { Container } from './snackbarItem.sc';

interface Props {
  id: string;
  txtKey: string;
  txt: string;
  animationTimeout: number;
  type?: NotificationTypes;
  iconName?: SvgIconName;
  persistent?: boolean;
  position: 'top' | 'bottom';
  removeItem(key: string): void;
}

const SnackbarItem: FC<Props> = (props) => {
  const timeoutId = useRef<number>();
  const iconName = props.type === 'error' ? 'iconDanger' : props.iconName;
  useEffect(() => {
    if (!props.persistent) {
      timeoutId.current = window.setTimeout(removeItem, 5000);
      return removeTimeout;
    }
  }, []);

  const removeItem = () => props.removeItem(props.id);

  const removeTimeout = () => {
    window.clearTimeout(timeoutId.current);
  };

  const vbDimensions = iconName === 'iconDanger' ? 60 : undefined;

  return (
    <Container className={props.position} $animationTimeout={props.animationTimeout} onClick={removeTimeout}>
      {iconName && (
        <div className="icon-box">
          <SvgIcon name={iconName} viewBoxWidth={vbDimensions} viewBoxHeight={vbDimensions} />
        </div>
      )}
      <div data-translation={props.txtKey} className="txt">
        {props.txt}
      </div>
      <button type="button" className="close-btn" onClick={removeItem}>
        <SvgIcon name="iconCross" width={15} viewBoxWidth={25} viewBoxHeight={25} />
      </button>
    </Container>
  );
};
export default SnackbarItem;
